import { useParams } from "react-router-dom";
import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import Toast from "../Util/Toast/Toast";
import { useEffect, useState } from "react";
import sleep from 'sleep-promise';

function Form() {

    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const getForm = (values) => {

        let path = '/core/examples/crud/frontend/';
        const paths = {
            urlGoBack: path+'list',
            pathView: path+'view',
        }
    
        const labels = {
            labelTitleAdd:  "Formulário",
            labelTitleEdit: "Editar Formulário",
            labelTitleView: 'Visualizar Formulário'
        }

        const form = {
            validateOnChange: true,
            showGoBackButton: false,
            handleSubmit: (form,values) => {
                Toast.success('Formulário atualizado com sucesso!');
            },
            fields: [
                {
                    name: 'select_form',
                    type: 'select',
                    label: 'Formulário',
                    options: [
                        {label: 'Formulário 1',value:1},
                        {label: 'Formulário 2',value:2},
                    ],
                    validations: {
                        required: true
                    },
                    handleChange: async (element,field,values) => {
                        const form = getForm(values);
                        form.values = values;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    columnSize: 12
                },
                {
                    name: 'text_teste',
                    type: 'text',
                    label: 'Text',
                    autoFocus:true,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                (values.select_form == 2)?{
                    name: 'text_teste2',
                    type: 'text',
                    label: 'Text 2',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }:{},
                {
                    name: 'email_teste',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'check',
                    type: 'checkbox',
                    label: 'Checkbox',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },       
            ],
            values: {
            },
            ...paths,
            ...labels
        }   
        return form;
    }

    useEffect(()=>{
        const form = getForm({});
        setForm(form);
        setFormContent(
            <CustomFormContainer 
                form = {form}
                content = {<CustomForm form={form}/>}
            />
        )
    },[])

    return (
        <div>
            {form && (
                <div>{formContent}</div>
             )
             }

        </div>
    );
}
export default Form;
